import { useState } from 'react'
import * as theme from '../lib/theme'

/** Dark / Light, in the chrome.
 *
 *  The same two-button control the approved mockup carries
 *  (docs/design/dispatch-panel-mockup.html), rather than an icon that toggles.
 *  Two labelled buttons say what the options ARE and which one you are on; a
 *  single sun-or-moon icon means guessing whether it shows the current state or
 *  the thing it will switch to, which is a coin flip every time.
 *
 *  `aria-pressed` carries the state for a screen reader, which is also how the
 *  mockup does it.
 */
export function ThemeToggle() {
  const [now, setNow] = useState<theme.Theme>(theme.current)

  function choose(next: theme.Theme) {
    theme.set(next)
    setNow(next)
  }

  return (
    <div className="themeset" role="group" aria-label="Colour scheme">
      {(['dark', 'light'] as const).map((t) => (
        <button
          key={t}
          type="button"
          aria-pressed={now === t}
          onClick={() => choose(t)}
        >
          {t === 'dark' ? 'Dark' : 'Light'}
        </button>
      ))}
    </div>
  )
}
